import type { Template } from "@/types";

export const PO_07_H5_V2: Template[] = [
    {
        id: "po-07-h5v2-01",
        name: "PO 01 - H5V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h5_v2_01.png",
        size: [1311, 820],
        style: {},
        slots: [
            { id: "1", x: 318, y: 151, width: 290, height: 520, rotation: 0, imageRotation: 0 },        
            { id: "3", x: 45, y: 151, width: 265, height: 168, rotation: 0, imageRotation: 0 },
            { id: "4", x: 45, y: 327, width: 265, height: 168, rotation: 0, imageRotation: 0 },
            { id: "5", x: 45, y: 503, width: 265, height: 168, rotation: 0, imageRotation: 0 },
            { id: "6", x: 720, y: 230, width: 252, height: 176, rotation: 0, imageRotation: 0 },
            { id: "7", x: 720, y: 414, width: 252, height: 176, rotation: 0, imageRotation: 0 },
            { id: "2", x: 980, y: 230, width: 252, height: 360, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "po-07-h5v2-02",
        name: "PO 02 - H5V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h5_v2_02.png",
        size: [1311, 820],
        style: {},
        slots: [
            { id: "1", x: 73, y: 164, width: 508, height: 319, rotation: 0, imageRotation: 0 },
            { id: "2", x: 73, y: 490, width: 116, height: 165, rotation: 0, imageRotation: 0 },
            { id: "3", x: 196, y: 490, width: 264, height: 165, rotation: 0, imageRotation: 0 },
            { id: "4", x: 467, y: 490, width: 115, height: 165, rotation: 0, imageRotation: 0 },
            { id: "5", x: 730, y: 164, width: 508, height: 325, rotation: 0, imageRotation: 0 },
            { id: "6", x: 730, y: 496, width: 250, height: 158, rotation: 0, imageRotation: 0 },
            { id: "7", x: 987, y: 496, width: 250, height: 158, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h5v2-03",
        name: "PO 03 - H5V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h5_v2_03.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 41, y: 157, width: 239, height: 152, rotation: 0, imageRotation: 0 },
            { id: "2", x: 41, y: 316, width: 239, height: 151, rotation: 0, imageRotation: 0 },
            { id: "3", x: 41, y: 474, width: 239, height: 151, rotation: 0, imageRotation: 0 },
            { id: "4", x: 287, y: 157, width: 302, height: 468, rotation: 0, imageRotation: 0 },
            { id: "5", x: 689, y: 157, width: 498, height: 239, rotation: 0, imageRotation: 0 },
            { id: "6", x: 689, y: 403, width: 330, height: 221, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1026, y: 403, width: 161, height: 221, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h5v2-04",
        name: "PO 04 - H5V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h5_v2_04.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 0, y: 214, width: 534, height: 356, rotation: 0, imageRotation: 0 },
            { id: "2", x: 541, y: 214, width: 137, height: 174, rotation: 0, imageRotation: 0 },
            { id: "3", x: 973, y: 214, width: 279, height: 174, rotation: 0, imageRotation: 0 },
            { id: "4", x: 685, y: 214, width: 281, height: 174, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1116, y: 395, width: 136, height: 174, rotation: 0, imageRotation: 0 },
            { id: "6", x: 541, y: 395, width: 281, height: 174, rotation: 0, imageRotation: 0 },
            { id: "7", x: 829, y: 395, width: 280, height: 174, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h5v2-05",
        name: "PO 05 - H5V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h5_v2_05.png",
        size: [1311, 820],
        style: {},
        slots: [
            { id: "1", x: 49, y: 225, width: 342, height: 219, rotation: 0, imageRotation: 0 },
            { id: "2", x: 399, y: 225, width: 342, height: 219, rotation: 0, imageRotation: 0 },
            { id: "3", x: 49, y: 451, width: 226, height: 143, rotation: 0, imageRotation: 0 },
            { id: "4", x: 283, y: 451, width: 225, height: 143, rotation: 0, imageRotation: 0 },
            { id: "5", x: 516, y: 451, width: 225, height: 143, rotation: 0, imageRotation: 0 },
            { id: "6", x: 749, y: 225, width: 253, height: 370, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1010, y: 225, width: 252, height: 370, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h5v2-06",
        name: "PO 06 - H5V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h5_v2_06.png",
        size: [1311, 820],
        style: {},
        slots: [
            { id: "1", x: 53, y: 511, width: 296, height: 187, rotation: 0, imageRotation: 0 },
            { id: "2", x: 660, y: 121, width: 295, height: 382, rotation: 0, imageRotation: 0 },
            { id: "3", x: 963, y: 121, width: 295, height: 382, rotation: 0, imageRotation: 0 },
            { id: "4", x: 53, y: 121, width: 599, height: 382, rotation: 0, imageRotation: 0 },         
            { id: "5", x: 357, y: 511, width: 295, height: 187, rotation: 0, imageRotation: 0 },
            { id: "6", x: 660, y: 511, width: 295, height: 187, rotation: 0, imageRotation: 0 },
            { id: "7", x: 963, y: 511, width: 295, height: 187, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h5v2-07",
        name: "PO 07 - H5V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h5_v2_07.png",
        size: [1311, 820],
        style: {},
        slots: [
            { id: "1", x: 0, y: 170, width: 229, height: 156, rotation: 0, imageRotation: 0 },
            { id: "2", x: 0, y: 333, width: 229, height: 155, rotation: 0, imageRotation: 0 },
            { id: "3", x: 0, y: 495, width: 229, height: 155, rotation: 0, imageRotation: 0 },
            { id: "4", x: 237, y: 170, width: 371, height: 481, rotation: 0, imageRotation: 0 },
            { id: "5", x: 615, y: 170, width: 369, height: 481, rotation: 0, imageRotation: 0 },
            { id: "6", x: 991, y: 170, width: 320, height: 237, rotation: 0, imageRotation: 0 },
            { id: "7", x: 991, y: 414, width: 320, height: 237, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h5v2-08",
        name: "PO 08 - H5V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h5_v2_08.png",
        size: [1311, 820],
        style: {},
        slots: [
            { id: "1", x: 0, y: 170, width: 229, height: 156, rotation: 0, imageRotation: 0 },
            { id: "2", x: 0, y: 333, width: 229, height: 155, rotation: 0, imageRotation: 0 },
            { id: "3", x: 0, y: 495, width: 229, height: 155, rotation: 0, imageRotation: 0 },
            { id: "4", x: 237, y: 170, width: 371, height: 481, rotation: 0, imageRotation: 0 },
            { id: "5", x: 615, y: 170, width: 320, height: 237, rotation: 0, imageRotation: 0 },
            { id: "6", x: 615, y: 414, width: 320, height: 237, rotation: 0, imageRotation: 0 },
            { id: "7", x: 942, y: 170, width: 369, height: 481, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h5v2-09",
        name: "PO 09 - H5V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h5_v2_09.png",
        size: [1311, 820],
        style: {},
        slots: [
            { id: "1", x: 53, y: 148, width: 191, height: 126, rotation: 0, imageRotation: 0 },
            { id: "2", x: 53, y: 282, width: 191, height: 125, rotation: 0, imageRotation: 0 },
            { id: "3", x: 53, y: 415, width: 191, height: 125, rotation: 0, imageRotation: 0 },
            { id: "4", x: 53, y: 548, width: 191, height: 125, rotation: 0, imageRotation: 0 },
            { id: "5", x: 251, y: 148, width: 809, height: 525, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1069, y: 148, width: 188, height: 259, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1069, y: 415, width: 188, height: 258, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h5v2-10",
        name: "PO 10 - H5V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h5_v2_10.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 51, y: 141, width: 773, height: 501, rotation: 0, imageRotation: 0 },
            { id: "2", x: 831, y: 141, width: 182, height: 121, rotation: 0, imageRotation: 0 },
            { id: "3", x: 831, y: 268, width: 182, height: 121, rotation: 0, imageRotation: 0 },
            { id: "4", x: 831, y: 395, width: 182, height: 121, rotation: 0, imageRotation: 0 },
            { id: "5", x: 831, y: 522, width: 182, height: 120, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1020, y: 141, width: 180, height: 247, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1020, y: 395, width: 180, height: 247, rotation: 0, imageRotation: 0 }
        ],
    }
];